module.exports = __webpack_public_path__ + "static/phone@2x.75b1e60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/phone@2x.png
// module id = 199
// module chunks = 68530290604204 153456355441848